<template>
    <svg id="Layer_1"
         enable-background="new 0 0 56.69 56.69"
         viewBox="0 0 56.69 56.69"
         xmlns="http://www.w3.org/2000/svg"
         class="icon-arrow">
        <g>
            <path
                  d="m46.005 41.676c-1.202 0-2.332-.469-3.182-1.318l-14.478-14.479-14.477 14.478c-.849.85-1.979 1.318-3.182 1.318s-2.333-.468-3.183-1.318c-1.754-1.754-1.754-4.609 0-6.363l17.66-17.661c.849-.85 1.979-1.318 3.181-1.318 1.201 0 2.332.468 3.182 1.318l17.66 17.661c.851.85 1.318 1.979 1.318 3.182 0 1.201-.468 2.332-1.318 3.182-.849.849-1.979 1.318-3.181 1.318zm-17.66-18.625 15.892 15.893c.945.945 2.59.945 3.535 0 .473-.473.732-1.101.732-1.768s-.26-1.295-.732-1.768l-17.705-17.704c-.945-.902-2.56-.887-3.489.043l-17.661 17.661c-.975.975-.975 2.561 0 3.535.945.945 2.592.945 3.536 0z" />
        </g>
    </svg>
</template>
<style lang="scss" scoped>
.icon-arrow {
    display: flex;
    flex-direction: column;
    pointer-events: none;
    width: 20px;
    height: 20px;

    &:deep path {
        transition: fill 0.2s ease-out;
        fill: currentColor;
    }
}
</style>
